/*SsrsComponent */

export const textBox: string = "TextBox";
export const datePicker: string = "CalenderSelect";
export const select: string = "DropDown";
export const checkboxList: string = "CheckBoxList";

export const pdfReportType: string = "pdf";
export const htmlReportType: string = "html";
export const csvReportType: string = "csv";
export const xmlReportType: string = "xml";
export const excelReportType: string = "xlsx"

export const ssrsReportLoadingMessage: string = "Please wait while report is loading..";
export const ssrsRequiredFieldButtonMessage: string = "indicates a required field";
export const ssrsRequiredFieldMessage: string = "Input required";
export const ssrsReportName: string = "Reports";
export const dateRangeErrorMessage: string = "From date should not be greater than To Date";

export const showMore: string = "Show More";
export const showLess: string = "Show Less";
export const showAll: string = "Show All";

/*Resolution Template*/
export const domLayout: string = "autoHeight";
export const noRowsTemplate: string = "No results found.";
export const loadingTemplate: string = "data is loading...";

/*tabbed toc view all Qna answers page*/
export const unpublishQnA: string = "Unpublish Question and Answer";
export const publishAnswer: string = "Publish Answer";
export const answerQuestion: string = "Answer Question";
export const updateQnA: string = "Update";
export const deleteQuestion: string = "Delete Question";
export const editQuestion: string = "Edit Question";
export const submitQuestion: string = "Submit Question";
export const updateQuestion: string = "Update";

export const statusAnswered: string = "Answered";
export const statusSubmitted: string = "Submitted";
export const statusUnpublish: string = "Unpublish";

export const buttonViewUnansweredQ: string = "View Unanswered Questions";
export const buttonViewAnsweredQ: string = "View Answered Questions";

export const Action_InsertAnswer: string = "InsertAnswer";
export const Action_UpdateQnA: string = "UpdateQnA";
export const Action_EditQuestion: string = "EditQuestion";
export const Action_DeleteQuestion: string = "DeleteQuestion";
export const Action_UnpublishOrReject: string = "UnpublishOrReject";
export const requiredAnswerMessage: string = "Please enter answer.";
export const blankSpaceMessage: string = "Blank spaces are not allowed.";




declare var ReadAngularLogs;

export function AddLogs(message: string) {
    var IsEnableLogs = ReadAngularLogs();
    if (IsEnableLogs.toLowerCase() == 'true') {
        console.log(message);
    }
}
